import { render, staticRenderFns } from "./UPList.vue?vue&type=template&id=a70225f8"
import script from "./UPList.vue?vue&type=script&lang=js"
export * from "./UPList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports